export const DAYS = 'Days';
export const HOURS = 'Hours';
export const MINS = 'Mins';
export const SECONDS = 'Seconds';

export const SORT_BY_DATE = 'sortByDate';
export const SORT_BY_UNREAD = 'sortByUnread';
export const RESOLVE_FILTER = 'resolveFilter';
export const MY_THREAD_FILTER = 'myThreadsFilter';

export const SUB_PATHWAY = 'sub-pathway';

export const SORT_BY_DATE_LABEL = 'Sort by date';
export const SORT_BY_UNREAD_LABEL = 'Sort by unread';
export const RESOLVE_FILTER_LABEL = 'Show resolved comments';
export const MY_THREAD_FILTER_LABEL = 'Only my threads';
export const INTERACTIVE = 'INTERACTIVE';
export const PATHWAY = 'PATHWAY';
export const ACTIVITY = 'ACTIVITY';
export const COMMENTING = 'commenting';
export const REPLYING = 'replying';
export const SEARCH_FILTERS = 'searchFilters';
export const SUB_ACTIVITY_NAME = 'Embeddable Lesson';
export const SORTERS_LIST_ITEMS = [
  {
    type: SORT_BY_DATE,
    label: SORT_BY_DATE_LABEL,
  },
  {
    type: SORT_BY_UNREAD,
    label:  SORT_BY_UNREAD_LABEL,
  },
];
export const FILTERS_LIST_ITEMS = [
  {
    type: RESOLVE_FILTER,
    label: RESOLVE_FILTER_LABEL,
  },
  {
    type: MY_THREAD_FILTER,
    label: MY_THREAD_FILTER_LABEL,
  },
];
export const SORT_OPTIONS = SORTERS_LIST_ITEMS.map(({ type }) => type);
export const FILTER_OPTIONS = FILTERS_LIST_ITEMS.map(({ type }) => type);

export const COMMENT_MOUSE_EVENT = 'commentMouseEvent';
